import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import logoAcelerai from "@/assets/logo-acelerai.png";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border/40 py-14">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src={logoAcelerai} 
                alt="Acelerai" 
                className="h-12 object-contain"
                loading="lazy"
                decoding="async"
                width={160}
                height={48}
              />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-light">
              Conectando parceiros aos melhores produtos financeiros do mercado.
            </p>
          </div>

          {/* Links */}
          <div>
            <h2 className="font-semibold text-foreground text-sm mb-4 uppercase tracking-wider">Links Rápidos</h2>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#beneficios" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Benefícios
                </a>
              </li>
              <li>
                <a href="#como-funciona" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="#servicos" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Serviços
                </a>
              </li>
              <li>
                <Link to="/cadastro" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Seja Parceiro
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="font-semibold text-foreground text-sm mb-4 uppercase tracking-wider">Institucional</h2>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/termos" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Termos de Uso
                </Link>
              </li>
              <li>
                <Link to="/privacidade" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Perguntas Frequentes
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-foreground transition-colors font-light">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="font-semibold text-foreground text-sm mb-4 uppercase tracking-wider">Contato</h2>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2 text-muted-foreground font-light">
                <Mail className="w-3.5 h-3.5 shrink-0" />
                faleconosco@hubacelerai.com.br
              </li>
              <li className="flex items-center gap-2 text-muted-foreground font-light">
                <MapPin className="w-3.5 h-3.5 shrink-0" />
                São Paulo, SP
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/40 pt-6 text-center space-y-1">
          <p className="text-muted-foreground text-xs font-light">
            © {new Date().getFullYear()} Aceleraí. Todos os direitos reservados.
          </p>
          <p className="text-muted-foreground text-xs font-light">
            CNPJ: 64.495.293/0001-08 - ACELERA BRASIL SOLUÇÕES LTDA.
          </p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
